<template>
  <div>
  <v-navigation-drawer
    ref="drawer"
    :value="drawerAberto"
    @input="drawerAberto = $event"
    fixed
    app
    :width="width"
    clipped
    floating
  >
      <v-container v-if="dataLoaded">
        <v-layout row justify-end>
          <v-btn icon small @click="fecharDrawer" aria-label="Fechar Sidebar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-layout>
        <folder-entity :maxWidth="width"/>
        <v-slider
          v-model="width"
          min="320"
          max="500"
          :step="0.5">
        </v-slider>
        <folder-info/>
        <v-layout justify-center v-if="!folderRules.canBeSentFolder(folder,user,folderStatusArchived)">
          <v-expansion-panel popout>
            <v-expansion-panel-content class="info-expansion">
              <template v-slot:header>
                <v-icon color="blue" class="mr-1">
                  mdi-information
                </v-icon>
                <span class="font-weight-bold grey--text">Não é possível tramitar este processo</span>
              </template>
              <v-layout column class="pl-5 pb-3">
                <span class="caption font-weight-bold grey--text">Motivos:</span>
                <span class="caption grey--text" v-if="folderRules.folderIsEmpty(folder)">
                - O processo está vazio
              </span>
                <span class="caption grey--text" v-if="folderRules.folderHasPendingSignature(folder)">
                - O processo tem assinatura(s) pendente(s)
              </span>
                <span class="caption grey--text" v-if="folderRules.folderHasPendingRevision(folder)">
                - O processo tem revisão(ões) pendente(s)
              </span>
                <span class="caption grey--text" v-if="folderRules.folderIsRequestedOwnership(folder)">
                - O processo foi solicitado
              </span>
                <span class="caption grey--text" v-if="!folderRules.folderOwnerIsYou(folder,user)">
                - O processo não está em sua posse
              </span>
                <span class="caption grey--text" v-if="folderRules.folderHasPendingReceipt(folder)">
                - O processo tem uma tramitação pendente de recebimento
              </span>
                <span class="caption grey--text" v-if="folderRules.folderArchived(folderStatusArchived,folder)">
                - O processo está arquivado
              </span>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
        <v-divider class="mt-3 mb-1" dark/>
        <v-subheader class="px-0">
          Interessados
          <interested-dialog/>
        </v-subheader>
        <interesteds-avatar-list :interesteds="interesteds"/>
        <v-divider class="mt-4 mb-2" dark/>
        <v-layout row wrap>
          <v-subheader class="px-0">Registro de atividades</v-subheader>
          <v-flex xs12>
            <folder-activity-log/>
          </v-flex>
        </v-layout>
      </v-container>
  </v-navigation-drawer>
    <v-fade-transition>
      <v-btn
        v-if="!drawerAberto"
        fab
        small
        fixed
        bottom
        right
        @click="drawerAberto = true"
        aria-label="Abrir Sidebar"
        class="sidebar-toggle-btn blue darken-1 white--text"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-fade-transition>
  </div>
</template>

<script>
import FolderActivityLog from '@/components/folder/activity-log/FolderActivityLog';
import FolderEntity from '@/components/folder/entity/FolderEntity';
import FolderInfo from '@/components/folder/info/FolderInfo';
import InterestedsAvatarList from '@/components/folder/interested/list/InterestedAvatarList';
import InterestedDialog from '@/components/folder/interested/edit/InterestedDialog';
import folderRules from '@/mixins/folder-validation';

export default {
  name: 'FolderSidebar',
  components: {
    FolderActivityLog,
    FolderEntity,
    FolderInfo,
    InterestedsAvatarList,
    InterestedDialog,
  },
  mixins: [folderRules],
  props: ['mode'],
  data() {
    return {
      width: 380,
      drawerAberto: true,
      info: true,
    };
  },
  methods: {
    fecharDrawer() {
      this.drawerAberto = false;
      // Se ainda tiver problemas, tente forçar a atualização
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    }
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
    user() {
      return this.$store.getters.user;
    },
    folderStatusArchived() {
      return this.$store.getters.folderStatusArchived;
    },
    interesteds() {
      if (this.folder == null || this.folder.interesteds_citizens == null
        || this.folder.interesteds_users == null) {
        return null;
      }
      const citizens = this.folder.interesteds_citizens;
      const users = this.folder.interesteds_users;
      return [...users, ...citizens];
    },
    loading() {
      return this.$store.getters.loading;
    },
    dataLoaded() {
      return !this.loading.show && this.interesteds !== null;
    },
  },
};
</script>

<style  lang="scss">
.info-expansion {
  .v-expansion-panel__header {
    padding: 5px;
  }
}

.sidebar-toggle-btn {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  position: fixed !important;
  z-index: 99 !important;
  left: 20px !important;
  top: 12px !important;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/folder/show/sidebar/FolderSidebar.vue